export enum PivotAggEnum {
  Sum = 'sum',
  Avg = 'avg',
  Count = 'count',
  Min = 'min',
  Max = 'max',
  First = 'first',
  Last = 'last'
}
